<div class="modifier-item" (click)="onClickEditModiferGroup()">
  <div class="modifier-content">
    <span class="modifier-name">{{ modifierGroup.name }}</span>
    <span class="modifier-description">{{ modifierGroup.description }}</span>
    <div class="modifier-modifiers-list">
      <div class="modifier-item-tag" *ngFor="let modifier of modifierGroup.modifierProducts">
        {{ GetModifierName(modifier.modifierId) }}
      </div>
    </div>
  </div>
  <div class="modifier-delete-btn">
    <button *ngIf="canEdit" mat-icon-button (click)="onClickDelete($event)">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>
